import React, { useEffect } from "react";

const AboutReviewModal = () => {

const handleClose = () => {
    window.loadModal2("#aboutReviewModal", "hide");
  };

  return (
    <div
      className="modal fade bd-example-modal-lg mt-5"
      id="aboutReviewModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="aboutReviewModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-preview">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="aboutReviewModalLabel">
              About Our Reviews
            </h5>
             <button
              type="button"
              className="close about-us-review-close"
              aria-label="Close"
              onClick={handleClose} // 👈 manual close
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body p-5">
            <p className="review-Popup">
              In an effort to be as transparent as possible, Mediums who have
              completed a sufficient number of sessions can publish recent
              reviews from clients (we remove identifying information and
              confidential details). We don’t cherry pick reviews or publish
              just the positive ones.
            </p>
            <br />
            <p className="review-Popup">
              We hope you will recognize both the quality of our Mediums and
              that mediumship is not an exact science and does not work
              perfectly every time, even for the most experienced Mediums. This
              balanced view of recent client experiences should give you a sense
              of the Medium’s style and results.
            </p>
            <br />
            <p className="review-Popup"> 
              We applaud our Mediums for choosing to publish their reviews,
              blemishes and all, to help bring more transparency to the
              mediumship profession.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutReviewModal;
